export {
    singlePostOpen,
    singlePostClose,
    incrementLikes
} from './posts';

export {
    showComments,
    addComments,
    deleteComments
} from './comments';


// WEBPACK FOOTER //
// ./src/Store/Actions/index.js